import { useState, useEffect } from 'react';
import * as db from '../db';

// React hook to access database functions
const useDatabase = () => {
  // Database state
  const [isLoading, setIsLoading] = useState(true);
  
  // Initialize database on component mount
  useEffect(() => {
    try {
      // Check database connection
      const categories = db.getMeatCategories();
      if (categories) {
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Database error:', error);
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    ...db
  };
};

export default useDatabase;